import { includes } from 'lodash-es';

import {
  CompanyVerificationRequest,
  CompanyVerificationRequestLegalDocument,
  RejectionReason,
  VerificationMethod,
} from '../../../common/interfaces/entities';

export type UpdateCompanyVerificationModalData = {
  hasCompanyNameMismatch: boolean;
  hasCompanyUniqueEntityNumberMismatch: boolean;
  document: CompanyVerificationRequestLegalDocument;
};

export function getUpdateCompanyVerificationModalData(
  lastVerificationRequest: CompanyVerificationRequest
): UpdateCompanyVerificationModalData | null {
  if (
    lastVerificationRequest.companyVerificationMethod.verificationMethod !==
    VerificationMethod.LEGAL_DOCUMENTS
  ) {
    throw new Error('Only legal documents verification is supported');
  }

  const document =
    lastVerificationRequest.document as CompanyVerificationRequestLegalDocument;
  const hasCompanyNameMismatch = includes(
    lastVerificationRequest.rejectionReasons,
    RejectionReason.AUTO_LEGAL_DOCUMENT_COMPANY_NAME_MISMATCH
  );
  const hasNumberMismatch = includes(
    lastVerificationRequest.rejectionReasons,
    RejectionReason.AUTO_LEGAL_DOCUMENT_NUMBER_MISMATCH
  );
  const hasCompanyUniqueEntityNumberMismatch =
    hasNumberMismatch && Boolean(document.acraBizFileMetadata?.uen);
  const extractedCompanyName =
    document.acraBizFileMetadata?.companyName ||
    document.companyNpwpDocumentMetadata?.companyName ||
    '';
  const canUpdateCompanyName = Boolean(
    hasCompanyNameMismatch && extractedCompanyName
  );

  if (!canUpdateCompanyName && !hasCompanyUniqueEntityNumberMismatch) {
    return null;
  }

  return {
    hasCompanyNameMismatch: canUpdateCompanyName,
    hasCompanyUniqueEntityNumberMismatch,
    document,
  };
}
